import { Button, Header, LoadingSpinner } from '@/components/Generic'
import type { CSSProperties } from 'react'
import { useContext, useEffect, useRef, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { observer } from 'mobx-react'
import { Illustration } from '@/components/Illustration/Illustration'
import { cx } from '@/utils/cx'

interface SuccessMultiSignerPendingPageProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trans: any
  fullName: string
  handleProceed: () => void
  handleFinishForNow: () => void
  btnLoading: boolean
}

export const SuccessMultiSignerPendingPage = observer(
  ({
    trans,
    fullName,
    handleProceed,
    handleFinishForNow,
    btnLoading,
  }: SuccessMultiSignerPendingPageProps) => {
    const buttonRef = useRef<HTMLButtonElement | null>(null)

    const store = useContext(StoreContext)
    const { isMobile, screenSize } = store.AppState

    const [containerMarginHeight, setContainerMarginHeight] = useState(0)
    const [mobileContainerHeight, setMobileContainerHeight] = useState('')

    useEffect(() => {
      if (screenSize.width && screenSize.width <= 980) {
        setMobileContainerHeight(`calc(${window.innerHeight}px - 120px)`)
      }
    }, [screenSize.width])

    useEffect(() => {
      if (buttonRef.current) {
        setContainerMarginHeight(buttonRef.current.offsetHeight + 90)
      }
    }, [buttonRef.current])

    return (
      <div className="page-container mobile-m-0">
        <div
          className="layout__content-container-with-scroll"
          style={
            isMobile
              ? ({ '--ccws-mobile-height': mobileContainerHeight } as CSSProperties)
              : undefined
          }
        >
          <Illustration type="sign-document-success" />
          <Header className="no-margin">{trans.header}</Header>
          <p className="generic__paragraph-centered">{trans.line1}</p>

          <div className="generic__spacer h-4" />

          <p className="generic__paragraph-centered">{trans.nextSignature}</p>

          <div className="enpal__name-wrapper">{fullName}</div>

          <div className="generic__spacer h-4" />

          <p className="generic__paragraph-centered">{trans.continueOnThisDevice}</p>

          <p className="generic__paragraph-centered">
            {`${trans.weHaveAlsoSent} ${fullName} ${trans.emailWithALink}`}
          </p>

          {isMobile ? (
            <div
              className="layout__margined"
              style={{ margin: `0 0 ${containerMarginHeight}px 0` }}
            />
          ) : (
            <div className="layout__margined m-0-0-15" />
          )}
        </div>

        <div className="layout__content-container-bottom-fixed-centered">
          <div className="layout__vertically-centered-container">
            <Button
              onClick={handleProceed}
              tabIndex={0}
              className="button--proceed"
              ref={buttonRef}
            >
              {btnLoading && <LoadingSpinner inButton />}
              <span
                className={cx(
                  'generic__button-text',
                  btnLoading && 'generic__button-text--loading'
                )}
                data-testId="proceed"
              >{`${trans.continueAs} ${fullName}`}</span>
            </Button>

            <div className="generic__spacer h-15" />

            <Button
              onClick={handleFinishForNow}
              className="button--secondary button--proceed"
              disabled={btnLoading}
              tabIndex={0}
            >
              <span className="generic__button-text" data-testId="proceed">
                {trans.finishForNow}
              </span>
            </Button>
          </div>
        </div>
      </div>
    )
  }
)
